module.exports = __webpack_public_path__ + "static/media/header-image-placeholder@3x.1.590403ba.jpg";